module.exports = __webpack_public_path__ + "static/media/mdm4.dc8b1951.png";